import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.groups-apps', {
        url: '/groups-apps',
        component: 'companyUserDirectoriesManageAccountGroupsApps',
        resolve: {
            groupsAndApps,
        },
    });
}

/** @ngInject */
function groupsAndApps(accountId, AccountsResource, companyId) {
    const isSmart = ({type}) => !['APPLICATION', 'CUSTOM'].includes(type);
    return AccountsResource.getAllGroupsForUserAccount(companyId, accountId)
        .then((pairs) => pairs.sort((p1, p2) => isSmart(p2.group) - isSmart(p1.group)));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/groups-apps.state.js